import axios from "axios";

import { BACKEND_URL } from "../constans";

export const axiosConfig = axios.create({
  baseURL: BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
